import { render } from "./ChessboardModule.html?vue&type=template&id=ead749e6&external"
import script from "./ChessboardModule.vue?vue&type=script&lang=js"
export * from "./ChessboardModule.vue?vue&type=script&lang=js"

import "./ChessboardModule.vue?vue&type=style&index=0&id=ead749e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__